import { EmptyCell, GenericValueFormatterFunc } from './genericFormatters';

export const StringArrayFormatter: GenericValueFormatterFunc<string[]> = ({ value }) => {
  return Array.isArray(value) ? value.join(', ') : EmptyCell;
};
